// Because we're using webpack and have configured it to understand `.scss`
// we're able to import this sass file and webpack will output it to a css file
import "./index.scss";
import "bootstrap";
import $ from 'jquery';
import './scripts/nav';
import './scripts/subnav';
// smoothscroll current page
function performSmoothscroll(element) {
    // expand accordion
    let offsetHeight = 0;
    if (element.classList.contains("collapse")) {
        $(element).collapse('show');
        if (element.classList.contains("accordion-item-body")) {
            offsetHeight = 80;
        }
    }
    // nav
    const nav = document.querySelector(".calendar-mobile-header");
    if (nav && window.innerWidth < 1024) {
        offsetHeight += nav.clientHeight;
    }
    var { top } = offset(element);
    const newTop = top - offsetHeight;
    // temporary solution for IE11
    if (isIE()) {
        window.scrollTo(0, newTop);
    }
    else {
        window.scrollTo({ top: newTop, behavior: "smooth" });
    }
}
$(document).on("click", "a[data-smoothscroll]", (e) => {
    let href = e.currentTarget.getAttribute("href");
    if (href.indexOf("#") === 0 && href.length > 1) {
        e.preventDefault();
        performSmoothscroll(document.querySelector(href));
    }
});
//document.querySelectorAll("a[data-smoothscroll]").forEach((el) => {
//    el.addEventListener("click", (e) => {
//        let href = (e.currentTarget as HTMLElement).getAttribute("href");
//        if (href.indexOf("#") === 0 && href.length > 1) {
//            e.preventDefault();
//            performSmoothscroll(document.querySelector(href));
//        }
//    });
//});
// smooth scroll on page loaded
const hash = window.location.hash;
if (!!hash && hash.length > 1) {
    $(window).on('load', function () {
        performSmoothscroll(document.querySelector(hash));
        // remove hash from url
        remove_hash_from_url();
    });
}
function remove_hash_from_url() {
    var uri = window.location.toString();
    if (uri.indexOf("#") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("#"));
        window.history.replaceState({}, document.title, clean_uri);
    }
}
function isIE() {
    return navigator.userAgent.match(/Trident\/7\./);
}
function offset(el) {
    var rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var marginTop = parseFloat(window.getComputedStyle(el).marginTop.replace("px", ""));
    return {
        top: rect.top + scrollTop - marginTop,
        left: rect.left + scrollLeft,
    };
}
